import classNames from "classnames";
import { ChevronDown, ChevronUp } from "../../../../../ui/Icon/Icon";
import styles from "./DetailSection.module.scss";
import { forwardRef, useState } from "react";

export type DetailRowProps = {
  name: React.ReactNode;
  children: React.ReactNode;
  direction?: "row" | "column";
};

function DetailRow({ name, children, direction = "row" }: DetailRowProps) {
  return (
    <div className={classNames(styles.detailRow, styles[direction])}>
      {typeof name === "string" ? <span>{name}</span> : name}
      {children}
    </div>
  );
}
type DetailSectionProp = {
  isOpen: boolean;
  setIsOpen: () => void;
  title: string;
  details: DetailRowProps[];
};
const DetailSection = forwardRef<HTMLDivElement, DetailSectionProp>(
  function DetailSection({ isOpen, setIsOpen, title, details }, ref) {
    const [detailsRef, setDetailsRef] = useState<HTMLDivElement | null>(null);

    const sectionHeight =
      isOpen && detailsRef?.scrollHeight ? `${detailsRef.scrollHeight}px` : 0;

    return (
      <div className={styles.detailSection}>
        <button
          type="button"
          className={classNames(styles.detailHeader, {
            [styles.isOpen]: isOpen,
          })}
          onClick={setIsOpen}
        >
          <h3 className={styles.detailTitle}>{title}</h3>
          {isOpen ? <ChevronDown size="medium" /> : <ChevronUp size="medium" />}
        </button>
        <div className={styles.detailsScrollableContainer} ref={ref}>
          <div
            ref={setDetailsRef}
            style={{
              height: sectionHeight,
            }}
            className={classNames(styles.details)}
          >
            {details.map((detail, index) => (
              <DetailRow key={index} {...detail} />
            ))}
          </div>
        </div>
      </div>
    );
  },
);

export default DetailSection;
